export const DefaultActions = [
    {
        key: "EDIT",
        icon: "mdi:pencil",
        ttLabel: "Edit",
        targetId: "edit",
        handler: "EDIT",
        iconWidth: 18
    },
    {
        key: "DELETE",
        icon: "mdi:delete",
        ttLabel: "Delete",
        targetId: "delete",
        handler: "DELETE",
        iconWidth: 18
    },
    {
        key: "VIEW",
        icon: "mdi:eye",
        ttLabel: "View",
        targetId: "view",
        handler: "VIEW",
        iconWidth: 18
    }
];